import React from 'react';
import {Switch} from "react-router-dom";
import {Provider} from 'react-redux';
import reduxStore from './Redux/reduxStore';
import './App.css';
import PrivateRoute from './Routers/PrivateRoute';
import PublicRoute from './Routers/PublicRoute';
import Login from './Components/Pages/Login';
import Dashboard from './Components/Pages/Dashboard';
import SeeApplication from './Components/Pages/SeeApplication';
import AddApplication from './Components/Pages/AddApplication';

function App() {
  return (
    <Provider store={reduxStore}>
      <div>
      <Switch>
          <PublicRoute  exact path='/' component={Login}/>
          <PublicRoute  exact path="/login" component={Login}/>
          <PrivateRoute exact path="/dashboard" component={Dashboard}/>
          <PrivateRoute exact path="/addApplication" component={AddApplication}/>
          <PrivateRoute exact path="/seeApplication" component={SeeApplication}/>
        </Switch>
      </div>
    </Provider>
  );
}

export default App;
